import { Record } from 'immutable';

export const mkPaymentMethod = Record({
  id: undefined,
  token: undefined,
  deleted: undefined,
  defaultMethod: undefined,
  isDeclined: undefined,
  isHardDeclined: undefined,
});
